import BaseComponent from '../base-component/base-component'

class FreeShippingBar extends BaseComponent {
  progressClass: string
  messageNodeSelector: string
  isFreeShippingAttribute: string
  differenceAttribute: string
  differencePercentAttribute: string
  progressMessageAttribute: string
  achievedMessageAttribute: string

  isFreeShipping: string
  difference: string
  differencePercent: number
  progressMessage: string
  achievedMessage: string

  constructor() {
    super()

    this.progressClass = '--gsc-free-shipping-progress'

    this.messageNodeSelector = '[data-free-shipping-bar-message]'
    this.isFreeShippingAttribute = 'data-free-shipping'
    this.differenceAttribute = 'data-free-shipping-difference'
    this.differencePercentAttribute = 'data-free-shipping-difference-percent'
    this.progressMessageAttribute = 'data-progress-message'
    this.achievedMessageAttribute = 'data-achieved-message'

    this.isFreeShipping = this.getAttribute(this.isFreeShippingAttribute)
    this.difference = this.getAttribute(this.differenceAttribute)
    this.differencePercent = +this.getAttribute(this.differencePercentAttribute)

    this.progressMessage =
      this.getAttribute(this.progressMessageAttribute) ?? ''
    this.achievedMessage =
      this.getAttribute(this.achievedMessageAttribute) ?? ''

    this.updateProgressByDifference(this.difference, this.differencePercent)
  }

  updateProgressByDifference(
    difference: string,
    differencePercent: number,
  ): void {
    if (differencePercent < 100) {
      this.setMessage(this.progressMessage.replace('[value]', difference))
      this.setProgress(differencePercent)
    } else {
      this.setMessage(this.achievedMessage)
      this.setProgress(100)
    }
  }

  setProgress = (value: number): void => {
    this.style.setProperty(this.progressClass, `${value}%`)
  }

  setMessage = (message: string): void => {
    const messageNode = this.querySelector(this.messageNodeSelector)

    if (messageNode) {
      messageNode.replaceChildren(message)
    }
  }
}

export default FreeShippingBar
